<template>
    <div class="center">
      <vs-dialog v-model="active" prevent-close @close="borrarInfo">
        <template #header>
          <h4 class="not-margin">
            Agregar configuración
          </h4>
        </template>
        <div class="con-form">
          <vs-row>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Componente académico
                        </label>
                        <vs-select filter class="aqui pt-0" id="institucion" placeholder="Componente académico" :key="componente_academicoId" v-model="componente_academico" :disabled="!componente_academicos.length" autocomplete="off">
                            <vs-option v-for="option in componente_academicos" :key="option.id"  :label="option.nombre" :value="option.id">
                                {{option.nombre}}
                            </vs-option>
                            <template #message-danger v-if="errorFields.includes('componente_academico')">
                                Requerido
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Detalle Componente académico
                        </label>
                        <vs-select filter class="aqui pt-0" id="institucion" placeholder="Detalle Componente académico" :key="detalle_componente_academicoId" v-model="detalle_componente_academico" :disabled="!detalle_componente_academicos.length" autocomplete="off">
                            <vs-option v-for="option in detalle_componente_academicos" :key="option.id"  :label="option.nombre" :value="option.id">
                                {{option.nombre}}
                            </vs-option>
                            <template #message-danger v-if="errorFields.includes('detalle_componente_academico')">
                                Requerido
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <label class="labelInput">Calificación</label>
                    <vs-select filter placeholder="Calificación" v-model="calificacion" class="pl-0 pt-0">
                        <vs-option label="Si" value="si">
                            Si
                        </vs-option>
                        <vs-option label="No" value="no">
                            No
                        </vs-option>
                        <template #message-danger v-if="errorFields.includes('calificacion')">
                            Requerido
                        </template>
                    </vs-select>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <label class="labelInput">Faltas</label>
                    <vs-select filter placeholder="Faltas" v-model="faltas" class="pl-0 pt-0">
                        <vs-option label="Si" value="si">
                            Si
                        </vs-option>
                        <vs-option label="No" value="no">
                            No
                        </vs-option>
                        <template #message-danger v-if="errorFields.includes('faltas')">
                            Requerido
                        </template>
                    </vs-select>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <label class="labelInput">Retardos</label>
                    <vs-select filter placeholder="Retardos" v-model="retardos" class="pl-0 pt-0">
                        <vs-option label="Si" value="si">
                            Si
                        </vs-option>
                        <vs-option label="No" value="no">
                            No
                        </vs-option>
                        <template #message-danger v-if="errorFields.includes('retardos')">
                            Requerido
                        </template>
                    </vs-select>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <label class="labelInput">Conducta</label>
                    <vs-select filter placeholder="Conducta" v-model="conducta" class="pl-0 pt-0">
                        <vs-option label="Si" value="si">
                            Si
                        </vs-option>
                        <vs-option label="No" value="no">
                            No
                        </vs-option>
                        <template #message-danger v-if="errorFields.includes('conducta')">
                            Requerido
                        </template>
                    </vs-select>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <label class="labelInput">Tareas no hechas</label>
                    <vs-select filter placeholder="Tareas no hechas" v-model="tareas_no_hechas" class="pl-0 pt-0">
                        <vs-option label="Si" value="si">
                            Si
                        </vs-option>
                        <vs-option label="No" value="no">
                            No
                        </vs-option>
                        <template #message-danger v-if="errorFields.includes('tareas_no_hechas')">
                            Requerido
                        </template>
                    </vs-select>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <label class="labelInput">Tipo de captura</label>
                    <vs-select filter placeholder="Tipo de captura" v-model="modo_captura" class="pl-0 pt-0">
                        <vs-option label="Sabana" value="sabana">
                            Sabana
                        </vs-option>
                        <vs-option label="Lista" value="lista">
                            Lista
                        </vs-option>
                        <template #message-danger v-if="errorFields.includes('modo_captura')">
                            Requerido
                        </template>
                    </vs-select>
                </vs-col>
                <vs-col sm="12" class="mt-3">
                    <h5>Captura</h5>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <label class="labelInput">Fecha de inicio</label>
                    <vs-input
                        type="date"
                        v-model="fecha_inicio_captura"
                        class="pl-0 pt-0"
                    >
                        <template #message-danger v-if="errorFields.includes('fecha_inicio_captura')">
                            Requerido
                        </template>
                    </vs-input>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <label class="labelInput">Hora de inicio</label>
                    <vs-input
                        type="time"
                        v-model="hora_inicio_captura"
                        class="pl-0 pt-0"
                    >
                        <template #message-danger v-if="errorFields.includes('hora_inicio_captura')">
                            Requerido
                        </template>
                    </vs-input>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <label class="labelInput">Fecha final</label>
                    <vs-input
                        type="date"
                        v-model="fecha_fin_captura"
                        class="pl-0 pt-0"
                    >
                        <template #message-danger v-if="errorFields.includes('fecha_fin_captura')">
                            Requerido
                        </template>
                    </vs-input>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <label class="labelInput">Hora final</label>
                    <vs-input
                        type="time"
                        v-model="hora_fin_captura"
                        class="pl-0 pt-0"
                    >
                        <template #message-danger v-if="errorFields.includes('hora_fin_captura')">
                            Requerido
                        </template>
                    </vs-input>
                </vs-col>
                <vs-col sm="12" class="mt-3">
                    <h5>Periodo</h5>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <label class="labelInput">Fecha de inicio</label>
                    <vs-input
                        type="date"
                        v-model="fecha_inicio_periodo"
                        class="pl-0 pt-0"
                    >
                        <template #message-danger v-if="errorFields.includes('fecha_inicio_periodo')">
                            Requerido
                        </template>
                    </vs-input>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <label class="labelInput">Fecha final</label>
                    <vs-input
                        type="date"
                        v-model="fecha_fin_periodo"
                        class="pl-0 pt-0"
                    >
                        <template #message-danger v-if="errorFields.includes('fecha_fin_periodo')">
                            Requerido
                        </template>
                    </vs-input>
                </vs-col>
                <vs-col sm="12" class="mt-3">
                    <h5>Generación de boletas</h5>
                </vs-col>
                <vs-row class="mb-3" v-for="(gen, j) in generacion_boleta" :key="j">
                    <vs-col sm="12" lg="6" class="d-flex">
                        <div class="vs-input-parent pl-0 pt-0 pb-0 vs-input-parent--state-null vs-component--primary">
                            <div class="vs-input-content">
                                <input class="vs-input" v-model="gen.date_time" type="date" :min="fecha_minima">
                            </div>
                        </div>
                    </vs-col>
                    <vs-col w="4" class="d-flex">
                        <vs-button
                            icon
                            size="mini"
                            color="success"
                            flat
                            id="addRow"
                            v-if="generacion_boleta.length < 4"
                            v-show="generacion_boleta.length == (j + 1)"
                            @click="addGeneracion()"
                        >
                            <i class="fas fa-plus" style="font-size: 0.8rem"></i>
                        </vs-button>
                        <vs-button
                            icon
                            size="mini"
                            color="danger"
                            flat
                            id="addRow"
                            v-if="generacion_boleta.length > 1"
                            @click="deleteGeneracion(j)"
                        >
                            <i class="fas fa-minus" style="font-size: 0.8rem"></i>
                        </vs-button>
                    </vs-col>
                    <vs-col>
                        <div class="vs-input__message vs-input__message--danger v-enter-to" >
                            <span v-if="errorFields.includes('generacion_boleta') && gen.date_time == ''">Requerido</span>
                            <span v-if="fecha_menor">La fecha y hora debe de ser mayor a 24 horas</span>
                        </div>
                    </vs-col>
                </vs-row>
          </vs-row>
        </div>

        <template #footer>
          <div class="footer-dialog">
            <vs-row>
                  <vs-col lg="6">
                    <vs-button
                        danger
                        flat
                        @click="active = false"
                        style="width: 50%"
                    >
                        Cancelar
                    </vs-button>
                  </vs-col>
                  <vs-col lg="6">
                    <vs-button
                        success
                        :disabled="fecha_menor"
                        @click="getCrearConfiguracion()"
                        style="width: 50%"
                        class="ml-auto"
                    >
                        Aceptar
                    </vs-button>
                  </vs-col>
              </vs-row>
          </div>
        </template>
      </vs-dialog>
    </div>
</template>
<script>
import academico from '../../../../../api/requests/academico.js'
    export default {
        props:[
            'value',
            'institucion',
            'cicloEscolar',
            'programa'
        ],
      data:() => ({
        active: false,
        institucionId: (new Date()).getTime(),
        ciclosEscolares: [],
        cicloId: (new Date()).getTime(),
        calificacion: '',
        faltas: '',
        retardos: '',
        fecha_inicio_periodo: '',
        fecha_fin_periodo: '',
        fecha_inicio_captura: '',
        hora_inicio_captura: '',
        fecha_fin_captura: '',
        hora_fin_captura: '',
        conducta: '',
        tareas_no_hechas: '',
        activo_boleta: '',
        mostrar_acta: '',
        observaciones:'no',
        modo_captura: '',
        componente_academico: '',
        componente_academicos: [],
        componente_academicoId: (new Date()).getTime(),
        detalle_componente_academico: '',
        detalle_componente_academicos: [],
        detalle_componente_academicoId: (new Date()).getTime(),
        errorFields:[],
        generacion_boleta: [{
            date_time: ''
        }],
        fecha_menor: false
      }),
      created(){

      },
    computed:{
        fecha_minima(){
            const date = new Date();
            date.setDate(date.getDate() + 1)
            const day = String(date.getUTCDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const year = date.getFullYear();
            const fechaAll = year + '-' + month + '-' + day
                return fechaAll
        }
    },
    methods: {
        addGeneracion(){
            this.generacion_boleta.push({date_time:''})
        },
        deleteGeneracion(index){
            this.generacion_boleta.splice(index, 1)
        },
        // fechaMinimaGeneracion(fecha){
        //     console.log(fecha)
        //     const datePuesta = new Date(fecha)
        //     const date = new Date();
        //     date.setDate(date.getDate() + 1)
        //     console.log(date)
        //     if((datePuesta.getTime() + 60000) < date.getTime()){
        //         this.fecha_menor = true
        //     }else{
        //         this.fecha_menor = false
        //     }
        // },
        async getComponenteAcademico() {
            if(this.cicloEscolar){
                let params = {
                    institucion_id: this.institucion,
                    ciclo_escolar_id: this.cicloEscolar
                }
                const { data: response } = await academico.getComponenteAcademico(params)
                this.componente_academicos = response
                this.componente_academicoId = (new Date()).getTime()
            }
        },
        async getDetalleComponenteAcademico() {
            let params = {
                componente_academico_id: this.componente_academico,
            }
            const { data: response } = await academico.getDetalleComponenteAcademico(params)
            this.detalle_componente_academicos = response
            this.detalle_componente_academicoId = (new Date()).getTime()
        },
        
        sanityForm () {
            this.errorFields = []
            const generacion = this.generacion_boleta.map(e => e.date_time)
            console.log(generacion)
            if (generacion.includes('')) {
                this.errorFields.push('generacion_boleta')
            }
            if (!this.componente_academico) {
                this.errorFields.push('componente_academico')
            }
            if (!this.detalle_componente_academico) {
                this.errorFields.push('detalle_componente_academico')
            }
            if (!this.calificacion) {
                this.errorFields.push('calificacion')
            }
            if (!this.faltas) {
                this.errorFields.push('faltas')
            }
            if (!this.retardos) {
                this.errorFields.push('retardos')
            }
            if (!this.conducta) {
                this.errorFields.push('conducta')
            }
            if (!this.tareas_no_hechas) {
                this.errorFields.push('tareas_no_hechas')
            }
            if (!this.modo_captura) {
                this.errorFields.push('modo_captura')
            }
            if (!this.fecha_inicio_captura) {
                this.errorFields.push('fecha_inicio_captura')
            }
            if (!this.hora_inicio_captura) {
                this.errorFields.push('hora_inicio_captura')
            }
            if (!this.fecha_fin_captura) {
                this.errorFields.push('fecha_fin_captura')
            }
            if (!this.hora_fin_captura) {
                this.errorFields.push('hora_fin_captura')
            }
            if (!this.fecha_inicio_periodo) {
                this.errorFields.push('fecha_inicio_periodo')
            }
            if (!this.fecha_fin_periodo) {
                this.errorFields.push('fecha_fin_periodo')
            }
            if (!this.errorFields.length){
                return true
            } else {
                return null
            }
        },
        async getCrearConfiguracion(){
            if(this.sanityForm()){
                const loading = this.$vs.loading()
                try{
                    const fecha_hora_generacion = this.generacion_boleta.map(e => e.date_time)
                    const params = {
                        componente_academico_id: this.componente_academico,
                        detalle_componente_id: this.detalle_componente_academico,
                        ciclo_escolar_id: this.cicloEscolar,
                        institucion_id: this.institucion,
                        programa_id: this.programa,
                        observaciones: 'no',
                        calificacion: this.calificacion,
                        faltas: this.faltas,
                        retardos: this.retardos,
                        modo_captura: this.modo_captura,
                        fecha_inicio_periodo: this.fecha_inicio_periodo,
                        fecha_fin_periodo: this.fecha_fin_periodo,
                        fecha_inicio_captura: this.fecha_inicio_captura,
                        hora_inicio_captura: this.hora_inicio_captura,
                        fecha_fin_captura: this.fecha_fin_captura,
                        hora_fin_captura: this.hora_fin_captura,
                        conducta: this.conducta,
                        tareas_no_hechas: this.tareas_no_hechas,
                        activo_boleta: 'si',
                        mostrar_acta: 'si',
                        fecha_hora: fecha_hora_generacion
                    }
                    const response = await academico.getCrearConfiguracion(params)
                    loading.close()
                    this.$emit('refreshTable',true)
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Operación éxitosa',
                        text: 'Se creó la información correctamente'
                    })
                    this.borrarInfo()
                }catch(error){
                    console.error(error)
                    loading.close()
                }
            }
        },
        borrarInfo(){
            this.calificacion = ''
            this.faltas = ''
            this.retardos = ''
            this.modo_captura = ''
            this.fecha_inicio_periodo = ''
            this.fecha_fin_periodo = ''
            this.fecha_inicio_captura = ''
            this.hora_inicio_captura = ''
            this.fecha_fin_captura = ''
            this.hora_fin_captura = ''
            this.conducta = ''
            this.tareas_no_hechas = ''
            this.activo_boleta = 'si'
            this.mostrar_acta = 'si'
            this.observaciones ='no'
            this.generacion_boleta = [{
                date_time: ''
            }]
            this.active = false
        }
    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        institucion(){
            this.getComponenteAcademico()
        },
        cicloEscolar(){
            this.getComponenteAcademico()
        },
        componente_academico(){
            this.getDetalleComponenteAcademico()
        }
    }
    }
    //how change format personalice in date?
</script>

<style>
label{
    margin-bottom: 0;
}
</style>
